var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m.94 10 6.81 6.81v-6.06H19v-1.5H7.75V3.19zm5.31-3.19v6.38L3.06 10z",
    clipRule: "evenodd"
  })));
};
export { SvgArrowLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC45Mzk0MzggOS45OTk5MUw3Ljc0OTk5IDE2LjgxMDhMNy43NTAwNCAxMC43NTAzSDE5VjkuMjUwMjlINy43NTAwNUw3Ljc1MDEgMy4xODk0NUwwLjkzOTQzOCA5Ljk5OTkxWk02LjI1MDA3IDYuODEwNzNMNi4yNTAwMiAxMy4xODk0TDMuMDYwNzQgOS45OTk5Nkw2LjI1MDA3IDYuODEwNzNaIi8+Cjwvc3ZnPgo=";